// frontend/src/hooks/useManualControl.js
import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';

export default function useManualControl() {
  const [control, setControl] = useState(null);
  const [error, setError] = useState('');
  const refresh = useCallback(async (signal) => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}/boxlines/manual-control`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          },
          signal,
        },
      );
      if (!signal?.aborted) {
        setControl(data);
        setError('');
      }
      return data;
    } catch (err) {
      if (!signal?.aborted) {
        setControl(null);
        setError('현재 세션을 조회하지 못했습니다. 다시 시도해 주세요.');
      }
      return null;
    }
  }, []);
  useEffect(() => {
    const controller = new AbortController();
    refresh(controller.signal);
    const timer = setInterval(() => refresh(controller.signal), 30000);
    return () => {
      controller.abort();
      clearInterval(timer);
    };
  }, [refresh]);
  return { control, error, refresh };
}
